// Port of api/fuel/app/classes/filter/search/games/rules/query/collection_updated.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'collection_updated',
	field: function() { return 'c.collection_date_updated' }
})
